import {
	Box,
	Accordion,
	AccordionItem,
	AccordionButton,
	AccordionPanel,
	AccordionIcon,
	Heading,
	Spinner,
	Alert,
	AlertIcon,
	Tab,
	TabList,
	TabPanel,
	TabPanels,
	Tabs,
} from '@chakra-ui/react';
import moment from 'moment';
import WeeklyReport from '../components/WeeklyReport';
import Layout from '../components/layouts/main';
import useFetchReportDates from '../hooks/useFetchReportDates';

export default function ReportsPage() {
	const { reportDates, loading, error } = useFetchReportDates();

	if (loading) {
		return (
			<Box display="flex" alignItems="center" justifyContent="center" height="100%" pt={16}>
				<Spinner size="xl" color='#FF684B' thickness="4px" />
			</Box>
		);
	}

	if (error) {
		return (
			<Alert status="error">
				<AlertIcon />
				{error}
			</Alert>
		);
	}

	return (
		<Layout>
			<Box maxW="7xl" mx="auto" pt={12} px={{ base: 2, sm: 12, md: 17 }}>
				<Heading fontSize="3xl" mb={10} textAlign="center">
					Reports
				</Heading>

				<Tabs>
					<TabList>
						<Tab>Weekly Reports</Tab>
						<Tab>Monthly Reports</Tab>
					</TabList>

					<TabPanels>
						<TabPanel>
							<Accordion allowMultiple>
								{reportDates.map((date, index) => {
									if (date.weekly_increase_report && date.weekly_increase_report.length > 0) {
										return (
											<AccordionItem key={index}>
												<h2>
													<AccordionButton>
														<Box flex="1" textAlign="left">
															{moment(date.dateStart).format('DD.MM.Y')} - {moment(date.dateEnd).format('DD.MM.Y')}
														</Box>
														<AccordionIcon />
													</AccordionButton>
												</h2>
												<AccordionPanel pb={4}>
													{/* Render the WeeklyReport component for this date */}
													<WeeklyReport reportData={date} />
												</AccordionPanel>
											</AccordionItem>
										);
									}
									return null; // Explicitly return null for empty reports
								})}
							</Accordion>
						</TabPanel>

						<TabPanel>
							{/* You could use the same structure for Monthly Reports */}
							<Accordion allowMultiple>
								{/* Map over monthly reports here */}
							</Accordion>
						</TabPanel>
					</TabPanels>
				</Tabs>
			</Box>
		</Layout>
	);
}
